import {
  LocalStorageKey,
  LocalStorageService,
} from '../../shared/storage/local-storage';

export function getStoredPushFcmToken(): string {
  const raw = LocalStorageService.getValue(LocalStorageKey.pushFcmToken);
  return typeof raw === 'string' ? raw.trim() : '';
}

export function setStoredPushFcmToken(token: string | null): void {
  LocalStorageService.setValue(
    LocalStorageKey.pushFcmToken,
    token && token.trim() ? token.trim() : '',
  );
}

export function isPushPermissionPromptCompleted(): boolean {
  return (
    LocalStorageService.getValue(
      LocalStorageKey.pushPermissionPromptCompleted,
    ) === true
  );
}

export function setPushPermissionPromptCompleted(value: boolean): void {
  LocalStorageService.setValue(
    LocalStorageKey.pushPermissionPromptCompleted,
    value,
  );
}
